module.exports = function(value, selectedValue) {
    return value === selectedValue ? "selected" : "";
};


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/hbHelpers/markSelected.js
// module id = 6
// module chunks = 0